// Origin stamped by the backend on cards born from a click on a Meta (Facebook/Instagram)
// ad. Mirrors FazerAi::Kanban::Task::AD_SOURCE -- keep both in sync.
export const AD_SOURCE_KEY = 'meta-ads';
export const RESERVED_DIMENSION_KEYS = ['source', 'product', 'lost_reason'];

/**
 * Turns a human name into the stable key stored on the card ("Google Ads" -> "google-ads").
 * Accents are stripped so the key stays ASCII and comparable across locales.
 */
export const slugifySourceKey = name =>
  String(name)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const duplicateKeysFor = items => {
  const seen = new Set();
  const duplicates = new Set();

  items.forEach(item => {
    const key = String(item.key || slugifySourceKey(item.name)).toLowerCase();
    if (!key) return;

    if (seen.has(key)) duplicates.add(key);
    seen.add(key);
  });

  return duplicates;
};

export const isReservedDimensionKey = key =>
  RESERVED_DIMENSION_KEYS.includes(String(key).toLowerCase());

/**
 * The reasons a funnel lists, trimmed, without blanks or repeats in other casing.
 * Mirrors FazerAi::Kanban::Board#lost_reasons -- keep both in sync.
 */
export const normalizeLostReasons = reasons => {
  const seen = new Set();
  return (reasons || [])
    .map(reason => String(reason ?? '').trim())
    .filter(reason => {
      const key = reason.toLowerCase();
      if (!reason || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

/**
 * What the card's picker offers: the funnel's list, plus the card's own saved reason when
 * the list does not carry it, so opening an old card never drops what the agent wrote.
 */
export const lostReasonChoices = (reasons, savedReason) => {
  const listed = normalizeLostReasons(reasons);
  const saved = String(savedReason || '').trim();
  return !saved || listed.includes(saved) ? listed : [...listed, saved];
};
